import { render } from "./PageHeader.vue?vue&type=template&id=38be22ea"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\souvenirbrandsaward\\souvenirbrandsaward\\souvenirbrandsaward_FE\\souvenirbrandsaward_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__